module.exports = __webpack_public_path__ + "fonts/SawarabiGothic-Regular.28d35b15.ttf";